// @ts-ignore
import withErrorGuard from 'components/core/withErrorGuard';
import ChannelLiveStateProvider from './LiveStateProvider';

export default withErrorGuard()(ChannelLiveStateProvider) as typeof ChannelLiveStateProvider;
